import {
	CHAT_DELETE_MESSAGE,
	CHAT_DELETE_MESSAGE_ERROR,
	CHAT_DELETE_MESSAGE_STATUS,
	CHAT_DELETE_RECIPIENT_MESSAGE,
	CHAT_EDIT_MESSAGE,
	CHAT_EDIT_MESSAGE_ERROR,
	CHAT_EDIT_MESSAGE_STATUS,
	CHAT_EDIT_RECIPIENT_MESSAGE,
	CHAT_FETCH,
	CHAT_FETCH_ERROR,
	CHAT_FETCH_STATUS,
	CHAT_GET,
	CHAT_GET_ERROR,
	CHAT_GET_STATUS,
	CHAT_MESSAGES_FETCH,
	CHAT_MESSAGES_FETCH_ERROR,
	CHAT_MESSAGES_FETCH_STATUS,
	CHAT_STORE_MESSAGE,
	CHAT_STORE_MESSAGE_ERROR,
	CHAT_STORE_MESSAGE_STATUS,
	CHAT_STORE_RECIPIENT_MESSAGE,
	CHAT_START_ERROR,
	CHAT_START,
	CHAT_DELETE,
	CHAT_DELETE_STATUS,
	CHAT_DELETE_ERROR,
	CHAT_VIOLATIONS_GET,
	CHAT_VIOLATIONS_GET_ERROR,
	CHAT_REPORT_STATUS,
	CHAT_REPORT_ERROR,
	CHAT_MESSAGE_READ,
	CHAT_MESSAGES_FETCH_MORE_STATUS,
} from './types'

const initialState = {
	chatLoading: false,
	messagesLoading: false,
	messageMoreLoading: false,
	messageStatus: false,
	chatActionStatus: false,
	chatListLoading: false,
	chat: {},
	chats: [],
	messages: [],
	errors: [],
	chatsTotal: 0,
	messagesTotal: 0,
	chatViolations: [],
}

export const state = { ...initialState }

export default {
	[CHAT_START]: (state, payload) => {
		state.chat = payload
	},

	[CHAT_START_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CHAT_GET]: (state, payload) => {
		state.chat = payload
	},

	[CHAT_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CHAT_GET_STATUS]: (state, status) => {
		state.chatLoading = status
	},

	[CHAT_MESSAGES_FETCH]: (state, payload) => {
		state.messages = [...state.messages, ...payload.data]
		state.messagesTotal = payload.meta.total
	},

	[CHAT_MESSAGES_FETCH_STATUS]: (state, status) => {
		state.messagesLoading = status
	},

	[CHAT_MESSAGES_FETCH_MORE_STATUS]: (state, status) => {
		state.messageMoreLoading = status
	},

	[CHAT_MESSAGES_FETCH_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CHAT_FETCH]: (state, payload) => {
		state.chat = initialState.chat
		state.messages = initialState.messages
		state.chats = payload.data
		state.chatsTotal = payload.meta.last_page
	},

	[CHAT_FETCH_STATUS]: (state, status) => {
		state.chatListLoading = status
	},

	[CHAT_FETCH_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CHAT_STORE_MESSAGE]: (state, payload) => {
		state.messages = [payload, ...state.messages]
	},

	[CHAT_STORE_MESSAGE_STATUS]: (state, status) => {
		state.messageStatus = status
	},

	[CHAT_STORE_MESSAGE_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CHAT_EDIT_MESSAGE]: (state, payload) => {
		state.messages = [...state.messages.filter((element) => element.id !== payload.id), payload]
	},
	[CHAT_EDIT_MESSAGE_STATUS]: (state, status) => {
		state.messageStatus = status
	},

	[CHAT_EDIT_MESSAGE_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CHAT_DELETE_MESSAGE]: (state, id) => {
		state.messages = state.messages.filter((message) => message.id !== id)
	},

	[CHAT_DELETE_MESSAGE_STATUS]: (state, status) => {
		state.messageStatus = status
	},

	[CHAT_DELETE_MESSAGE_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CHAT_STORE_RECIPIENT_MESSAGE]: (state, payload) => {
		state.messages = [payload, ...state.messages]
	},

	[CHAT_EDIT_RECIPIENT_MESSAGE]: (state, payload) => {
		state.messages = [...state.messages.filter((element) => element.id !== payload.id), payload]
	},

	[CHAT_DELETE_RECIPIENT_MESSAGE]: (state, id) => {
		state.messages = state.messages.filter((message) => message.id !== id)
	},

	[CHAT_DELETE]: (state, id) => {
		state.chat = state.chats.filter((chat) => chat.id !== id)
	},

	[CHAT_DELETE_STATUS]: (state, status) => {
		state.chatActionStatus = status
	},

	[CHAT_DELETE_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CHAT_VIOLATIONS_GET]: (state, payload) => {
		state.chatViolations = payload
	},

	[CHAT_VIOLATIONS_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CHAT_REPORT_STATUS]: (state, status) => {
		state.chatActionStatus = status
	},

	[CHAT_REPORT_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[CHAT_MESSAGE_READ]: (state, payload) => {
		state.messages.filter((a) =>
			payload.some((b) => {
				if (a.id === b) {
					a.is_read = true
				}
			})
		)
	},
}
